function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.66668 4C3.40306 4 4.00001 4.59695 4.00001 5.33333V24C4.00001 24.7364 4.59696 25.3333 5.33334 25.3333H29.3333C30.0697 25.3333 30.6667 25.9303 30.6667 26.6667C30.6667 27.403 30.0697 28 29.3333 28H5.33334C3.1242 28 1.33334 26.2091 1.33334 24V5.33333C1.33334 4.59695 1.9303 4 2.66668 4Z",
  fill: "#21D170"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 6.66675C23.2636 6.66675 22.6667 7.2637 22.6667 8.00008V21.3334C22.6667 22.0698 23.2636 22.6667 24 22.6667C24.7364 22.6667 25.3333 22.0698 25.3333 21.3334V8.00008C25.3333 7.2637 24.7364 6.66675 24 6.66675Z",
  fill: "#21D170"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 9.33341C12.5969 9.33341 12 9.93037 12 10.6667V21.3334C12 22.0698 12.5969 22.6667 13.3333 22.6667C14.0697 22.6667 14.6667 22.0698 14.6667 21.3334V10.6667C14.6667 9.93037 14.0697 9.33341 13.3333 9.33341Z",
  fill: "#21D170"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99999 17.3334C7.26361 17.3334 6.66666 17.9304 6.66666 18.6667V21.3334C6.66666 22.0698 7.26361 22.6667 7.99999 22.6667C8.73637 22.6667 9.33332 22.0698 9.33332 21.3334V18.6667C9.33332 17.9304 8.73637 17.3334 7.99999 17.3334Z",
  fill: "#21D170"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3333 13.3334C17.3333 12.597 17.9303 12.0001 18.6667 12.0001C19.403 12.0001 20 12.597 20 13.3334V21.3334C20 22.0698 19.403 22.6667 18.6667 22.6667C17.9303 22.6667 17.3333 22.0698 17.3333 21.3334V13.3334Z",
  fill: "#21D170"
});

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.7e9bcded.svg";
export { ForwardRef as ReactComponent };